// import styled from "styled-components";

// export const TranducerMessagesList = styled.div`
//   height: 100%;
//   overflow: auto;
//   ::-webkit-scrollbar {
//     display: none;
//   }
// `;

// export const Message = styled.div`
//   margin-bottom: 20px;
//   display: flex;
//   flex-direction: column;
//   align-items: ${({patient}) =>
//     patient
//       ? "flex-start"
//       : "flex-end"
//   };
//   .label {
//     font-family: Nunito Sans;
//     font-size: 16px;
//     color: #68688D;
//     margin-bottom: 5px;
//   }
//   .box {
//     /* width: ${({transducerType}) => transducerType === 2 ? "cacl(100% - 20px)" : "411px"}; ; */
//     border-radius: 14px;
//     padding: 10px;
//     border-bottom-left-radius: ${({patient}) => patient ? "0px" : "14px"};
//     border-bottom-right-radius: ${({patient}) => patient ? "14px" : "0px"};
//     background-color: ${({patient, transducerState}) =>
//       transducerState
//         ? patient ? "#F0F0FF" : "#D2D2FF"
//         : patient ? "#F0F0FF" : "#F8F8FF"
//       };
//   }
// `

import styled from "styled-components";

export const TranducerMessagesList = styled.div`
  height: 100%;
  overflow: auto;
  /* Ocultar scrollbar en todos los navegadores */
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const Message = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;

  /* LÓGICA DE ALINEACIÓN */
  /* Si es Batch (archivo), alineamos todo a la izquierda para leer como un guion médico.
     Si es tiempo real, mantenemos tu lógica original de paciente/médico. */
  align-items: ${({ patient, isBatch }) =>
    isBatch ? "flex-start" : patient ? "flex-start" : "flex-end"};

  .label {
    font-family: Nunito Sans;
    font-size: 14px;
    color: #68688d;
    margin-bottom: 5px;
    /* Estilo especial para el nombre de la persona en modo Batch */
    font-weight: ${({ isBatch }) => (isBatch ? "800" : "normal")};
    text-transform: ${({ isBatch }) => (isBatch ? "uppercase" : "none")};
  }

  .box {
    border-radius: 14px;
    padding: 12px 16px;
    font-family: Nunito Sans;
    font-size: 16px;
    line-height: 1.5;
    transition: all 0.3s ease;

    ${({ isBatch, patient, transducerState }) =>
      !isBatch &&
      `
        border-bottom-left-radius: ${patient ? "0px" : "14px"};
        border-bottom-right-radius: ${patient ? "14px" : "0px"};
        background-color: ${
          transducerState
            ? patient
              ? "#F0F0FF"
              : "#D2D2FF"
            : patient
              ? "#F0F0FF"
              : "#F8F8FF"
        };
        color: #333;
    `}
  }
`;
